import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { EUserType } from "../domain/enum/user-type";
import { User } from "../domain/user";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { UserDTO } from "./dto/user.dto";
import { AppConfig } from "../app.config";

@Injectable({
    providedIn: 'root',
})
export class UserService extends BaseService {

    private serviceUrl = `${this.config.getConfig('serviceBaseUrl')}api/user`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        protected override oauthService: OAuthService,
        private loadingTask: LoadingTask,
        protected override router: Router,
        private config: AppConfig) {
        super(router, coreData, oauthService, snackBare);
    }

    getRole() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/Role`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getRoles')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: EUserType) => {
                return response;
            }));
    }

    getAllUsers() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/All`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getAllUsers')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: UserDTO[]) => {
                return response.map((item: UserDTO) => {
                    return mapper.map(item, UserDTO, User);
                });
            }));
    }

    createUser(user: User) {

        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}`, JSON.stringify(user), this.generateHeader()).pipe(
            catchError(this.handleError<any>('createUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    updateUser(user: User) {

        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}`, JSON.stringify(user), this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    deleteUser(user: User) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${encodeURI(user.Email)}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    searchEIMASUser(email: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/EIMAS/${email}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('searchEIMASUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: UserDTO) => {
                return mapper.map(response, UserDTO, User);
            }));
    }

    logout() {

        this.loadingTask.activateLoading();
        // let body = {
        //     id: this.coreData.getUserFromJWTToken()!.PI_SRI
        // }
        return this.http.post(`${this.serviceUrl}/logout`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('logout')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }
}

